import { DireccionMenu, Menu } from "../menu";
import Mover from "../mover";
var configuraMenu = function () {
    var contenedor = document.querySelector("#menu-principal");
    if (contenedor instanceof HTMLElement) {
        var menu = new Menu(contenedor, DireccionMenu.HORIZONTAL);
        menu.inicializa(true);
        var opciones_1 = [].slice.call(contenedor.querySelectorAll('.menu > li'));
        window.addEventListener('resize', function () {
        });
    }
    var mover = new Mover();
    mover.monitoriza();
};
export default configuraMenu;
